import { removeStaticBannerImage } from './updatePrecautionNotification';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { updatePrecautionImageMutation as mutation } from '../../../lib/graphql';

export const updatePrecautionNotificationImage = ({ id, imageName }, oldImage) => {

    return async (dispatch, getState, { client }) => {
        try {
            if (oldImage) await removeStaticBannerImage(oldImage);

            const { data } = await client.mutate({
                mutation,
                variables: {
                    id,
                    imageName
                }
            });

            if (data?.updatePrecautionNotificationImage?.status == 200) {
                showToaster({ messageId: 'changesUpdated', toasterType: 'success' });
            } else {
                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updatePrecautionNotificationImage?.errorMessage }, toasterType: 'error' });
            }
        }
        catch (error) {
            showToaster({ messageId: 'catchMessage', requestContent: { content: error }, toasterType: 'error' });
        }
    };
}